/** Public org profile accepts `/organisation/{guid}` or `/organisation/{name-slug}`. */

export const ORGANISATION_PAGE_GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isOrganisationPageGuid(value: string | null | undefined): boolean {
  return !!value && ORGANISATION_PAGE_GUID_PATTERN.test(value.trim());
}

export function organisationPageSlug(name: string | null | undefined): string | null {
  const slug = (name ?? '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80)
    .replace(/-+$/g, '');

  return slug || null;
}

export function organisationPagePath(id: string, name?: string | null): string {
  const slug = organisationPageSlug(name);
  return slug ? `/organisation/${slug}` : `/organisation/${id.trim()}`;
}

export function organisationPageCommands(id: string, name?: string | null): string[] {
  const slug = organisationPageSlug(name);
  return slug ? ['/organisation', slug] : ['/organisation', id.trim()];
}
